import React from 'react';
import Hero from '../Hero/Hero';
import MyProjects from '../MyProjects/MyProjects';
import bg from '../../Assets/bghero1.png'
import Footer from './../Footer/Footer';
import MyServices from '../MyServices.js/MyServices';
import Navigation from './../Navigation/Navigation';

const Home = () => {
    return (
        <div className="" >
              <Navigation></Navigation>
            <div className="container herobg" style={{ background: `url(${bg})`, backgroundAttachment: "fixed", backgroundRepeat: "no-repeat", backgroundSize: "cover" }}>
            <Hero></Hero>
            <MyServices/>
            <MyProjects></MyProjects>
           </div>
            <Footer />
        </div>
    );
};

export default Home;